import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import detectorActivityFormMeta, { IDetectorActivityFormMeta } from "./DetectorActivityFormMeta";
import tapesFormMeta, { ITapesFormMeta } from "./TapesFormMeta";
import partsDistributorFormMeta, { IPartsDistributorFormMeta } from "./PartsDistributorFormMeta";
import othersFormMeta, { IOthersFormMeta } from "./OthersFormMeta";

export interface IDetectorsFormMeta extends IDetectorActivityFormMeta, ITapesFormMeta, IPartsDistributorFormMeta, IOthersFormMeta {
  lastUpdateDate: FormInputMeta;

  schema: any;
}

let detectorsFormMeta = {} as IDetectorsFormMeta;

detectorsFormMeta.lastUpdateDate = {
  name: "lastUpdateDate",
  type: "date",
  label: "Date Dernière MAJ",
  placeholder: "Date Dernière MAJ",
  validation: yup.date()
};

detectorsFormMeta = { ...detectorsFormMeta, ...detectorActivityFormMeta, ...tapesFormMeta, ...partsDistributorFormMeta, ...othersFormMeta }

detectorsFormMeta.schema = yup.object().shape(getValidationSchema(detectorsFormMeta));

export default detectorsFormMeta;